import styled from 'styled-components';

export type ChipTone = 'ok' | 'warn' | 'bad' | 'mute' | 'info';

const CHIP_FUNDO: Record<ChipTone, string> = { ok: '#e2f0ec', warn: '#fbf1df', bad: '#fbecef', mute: '#ebebeb', info: '#E6F4FB' };
const CHIP_TEXTO: Record<ChipTone, string> = { ok: '#1d6b5c', warn: '#b06f07', bad: '#a33a4e', mute: '#696969', info: '#0090D3' };

export const Chip = styled.span<{ $tone: ChipTone }>`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  border-radius: 100px;
  padding: 2px 9px;
  white-space: nowrap;
  background: ${({ $tone }) => CHIP_FUNDO[$tone]};
  color: ${({ $tone }) => CHIP_TEXTO[$tone]};
`;

export const ChapterLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
`;

export const ChapterSummary = styled.span`
  display: inline-flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const UsageLink = styled.button`
  border: 0;
  background: none;
  padding: 0;
  color: #0090d3;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
`;

export const UsageHint = styled.div<{ $bad?: boolean }>`
  font-size: 10.5px;
  color: ${({ $bad }) => ($bad ? '#a33a4e' : '#999')};
  font-weight: ${({ $bad }) => ($bad ? 600 : 400)};
  margin-top: 2px;
`;

export const MutedText = styled.span`
  color: #999;
`;
